<template>
  <label 
    class="sm-radiobutton"
    :class="['sm-radiobutton--' + type, {checked}]"
  >
    <input 
      type="radio"
      :name="name"
      @change="$emit('input', $event.target.checked)"
      :checked="checked"
    >
    <span class="text">{{text}}</span>
    <span 
      v-if="description"
      class="descr"
    >{{description}}</span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'radiobutton-block',
  props: {
    type: {
      type: String,
      default: 'base'
    },
    name: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>
